import { getChemicalTitle } from '@/utils/chemical'
import { compareChemicals } from '@/utils/chemical'

export const buildChemicalColumnDef = ({ showChemCell, pinned = true } = {}) => ({
  headerName: 'Chemical',
  field: 'chemical',
  headerCheckboxSelection: true,
  headerCheckboxSelectionFilteredOnly: true,
  checkboxSelection: true,

  cellStyle: { textAlign: 'left' },
  ...(pinned ? { pinned: 'left' } : {}),

  headerComponent: 'ColumnHeaderFilter',

  filter: 'agTextColumnFilter',

  ...(showChemCell
    ? {
        cellRenderer: 'ChemCellRenderer',
        suppressSizeToFit: true,
        autoHeight: true,
      }
    : {
        maxWidth: 200,
        minWidth: 150,
        tooltipComponent: 'ChemPropsWithCopyCardRenderer',
        tooltipComponentParams: (params) => ({
          chemical: params?.data?.chemical,
        }),

        tooltipValueGetter: (params) => {
          const name = params?.data?.chemical?.name
          const casrn = params?.data?.chemical?.casrn
          const smiles = params?.data?.chemical?.smiles
          return [name ? `Name: ${name}` : null, casrn ? `CASRN: ${casrn}` : null, smiles ? `SMILES: ${smiles}` : null]
            .filter(Boolean)
            .join('\n')
        },
      }),

  filterValueGetter: (params) => {
    const chemical = params?.data?.chemical
    if (!chemical) return ''
    return Object.values(chemical).filter(Boolean).join(' ').toLowerCase()
  },

  valueGetter: (params) => {
    if (!params?.data) return ''
    return params?.data?.chemical
  },

  valueFormatter: ({ value }) => getChemicalTitle(value) || 'N/A',

  comparator: (aValue, bValue, _nodeA, _nodeB, isDescending) => {
    return compareChemicals(aValue, bValue, isDescending)
  },
})
